module.exports = __webpack_public_path__ + "static/media/25.6eeb085a.jpg";